import React, { useContext, useState, useEffect } from 'react';
import { Button } from '@mui/material';
import NotificationIcon from '../../Assets/Images/Dashboardheader/notificationIcon.svg';
import NewNotificationIcon from '../../Assets/Images/Dashboardheader/newNotificationIcon.svg';
import CoinIcon from '../../Assets/Images/Dashboardheader/CoinIcon.svg';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { fetchTokens, listenForNotifications } from '../.././api';
import { TokenContext } from '../../Context/TokenContext';
import AuthContext from '../../Context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { DashboardContext } from '../../Context/DashboardContext';

const DashboardHeader = (props) => {

  //props
  const { heading, handleNotificationOpen } = props;

  // other hooks
  const tokenCtx = useContext(TokenContext);
  const authCtx = useContext(AuthContext)
  const dashboardCtx = useContext(DashboardContext)
  const navigate = useNavigate();

  // usestates 
  const [fullName, setFullName] = useState(authCtx?.userName)
  const [open, setOpen] = useState(false);
  const [initialOrgId, setIInitialOrgId] = useState(localStorage.getItem('orgId'))

  // useeffects 
  useEffect(() => {

    // fetching tokens... 
    const getToken = async () => {
      try {
        const result = await fetchTokens({ orgId: authCtx.orgId });
          console.log("result",result)

          const userDetails = result?.userData?.[0];

        if ( !userDetails?.phone || !userDetails?.role ) {
          // navigate(`/signup-details/${userDetails.organisationId}?toDashboard=true`)
          navigate(`/signup-details/${userDetails.organisationId}`, { state: { isDetailsIncomplete: true } })
        }

        if (result && result.orgTotalTokens) {
          tokenCtx.setSelectedToken(result.orgTotalTokens)
        }
      } catch (error) {
        console.error('Failed to fetch token:', error.message);
      }
    };
    authCtx?.setOrgId(initialOrgId)

    getToken();
  }, []);

  // functions
  const handleLogout = () => {
    authCtx.logout();
    localStorage.clear()
    setOpen(false);
    navigate("/login");
  }

  // logs 
  // console.log("unreadCount", dashboardCtx?.unreadCount)
  // console.log(tokenCtx.selectedToken)

  return (
    <div className='dashboard-header'>
      <p className='heading'>{heading}</p>
      <div className='acc-info'>
        <div className="notifications-container">
          <div className="notification-wrapper">
            {dashboardCtx?.unreadCount > 0 && (
              <div className="notification-tooltip">
                {dashboardCtx.unreadCount} new notifications
              </div>
            )}
            <Button
              sx={{ padding: 0, minWidth: 0, borderRadius: '100%' }}
              onClick={() => {
                dashboardCtx?.setUnreadCount(0);
                handleNotificationOpen();
              }}
            >
              <img
                src={
                  dashboardCtx?.unreadCount > 0
                    ? NewNotificationIcon
                    : NotificationIcon
                }
                alt="Notification"
              />
            </Button>
          </div>
        </div>

        <div className='coins'>
          <img src={CoinIcon} alt="Coin Icon" />
          <p>{tokenCtx.selectedToken === null || tokenCtx.selectedToken === undefined ? 'Loading...' : tokenCtx.selectedToken}</p>
        </div>
        <div className="profile-menu">
          <div className="profile-info" onClick={() => setOpen(!open)}>
            {/* <AccountCircleIcon className="profile-icon" /> */}
            <p>{fullName !== "null null" ? fullName : ""}</p>
          </div>
          {/* {open && (
              <div className="dropdown">
                <ul>
                  <li className="dropdown-item">Settings</li>
                  <li className="dropdown-item" onClick={() => handleLogout()}>
                    Logout
                  </li>
                </ul>
              </div>
            )} */}
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;
